import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function Solution() {
  return <Section className="bg-rose-50" data-id="element-114">
      <div className="text-center mb-12" data-id="element-115">
        <span className="text-rose-600 font-bold tracking-wider uppercase text-sm" data-id="element-116">
          Presentamos la solución
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-6" data-id="element-117">
          Mamá Digital: Cómo Ganar desde Casa con PDFs y WhatsApp
        </h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-118">
          Un ebook diseñado específicamente para mamás latinas en USA que
          quieren dar su primer paso real en el mundo digital sin complicarse.
        </p>
      </div>

      <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12" data-id="element-119">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-120">
          <div className="order-2 md:order-1" data-id="element-121">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-122">
              No es otro curso teórico más.
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-123">
              Es una guía práctica que te lleva de la mano desde "¿Qué podría
              vender yo?" hasta "Ya tengo mi PDF listo y mis primeros mensajes
              publicados".
            </p>

            <div className="space-y-4" data-id="element-124">
              <div className="flex items-start" data-id="element-125">
                <CheckCircle2 className="w-6 h-6 text-emerald-500 mt-1 mr-3 flex-shrink-0" data-id="element-126" />
                <div data-id="element-127">
                  <h4 className="font-semibold text-gray-900" data-id="element-128">
                    Tu experiencia de vida
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-129">
                    Usamos lo que ya sabes hacer.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-130">
                <CheckCircle2 className="w-6 h-6 text-emerald-500 mt-1 mr-3 flex-shrink-0" data-id="element-131" />
                <div data-id="element-132">
                  <h4 className="font-semibold text-gray-900" data-id="element-133">Tu celular</h4>
                  <p className="text-sm text-gray-500" data-id="element-134">
                    Tu única herramienta necesaria.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-135">
                <CheckCircle2 className="w-6 h-6 text-emerald-500 mt-1 mr-3 flex-shrink-0" data-id="element-136" />
                <div data-id="element-137">
                  <h4 className="font-semibold text-gray-900" data-id="element-138">
                    WhatsApp y redes
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-139">
                    Donde ya pasas tu tiempo.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 md:order-2 flex justify-center" data-id="element-140">
            <div className="relative w-64 h-80 bg-rose-100 rounded-lg shadow-inner flex items-center justify-center transform rotate-3 border-4 border-white" data-id="element-141">
              {/* Placeholder for cover representation if image not used here */}
              <div className="text-center p-6" data-id="element-142">
                <p className="font-serif text-2xl text-rose-800 font-bold mb-2" data-id="element-143">
                  Mamá Digital
                </p>
                <p className="text-rose-600 text-sm" data-id="element-144">Guía Práctica PDF</p>
                <div className="mt-8 w-16 h-16 bg-white rounded-full mx-auto flex items-center justify-center shadow-sm" data-id="element-145">
                  <span className="text-2xl" data-id="element-146">📱</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}